export default __webpack_public_path__ + "static/media/play_again.c0775252.png";